const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Screenshot%20style%20image%20of%20a%20breaking%20news%20studio%20with%20dramatic%20lighting%20and%20a%20headline%20banner%2C%20entertainment%20news%20channel%20aesthetic%2C%20warm%20coral%20and%20gold%20color%20scheme%2C%20professional%20TV%20newsroom%20set%2C%20dynamic%20composition%20with%20multiple%20screens&width=480&height=320&seq=91crab-media-01&orientation=landscape',
    title: '某顶流明星深夜发文引发全网震动',
    duration: '05:32',
    views: '128.6万',
    tag: '爆款',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20colorful%20RGB%20lighting%20and%20gaming%20chair%2C%20modern%20streamer%20setup%20with%20multiple%20monitors%2C%20vibrant%20purple%20and%20pink%20neon%20accents%2C%20professional%20content%20creation%20space%2C%20dynamic%20and%20energetic%20atmosphere&width=480&height=320&seq=91crab-media-02&orientation=landscape',
    title: '头部网红直播翻车完整回放记录',
    duration: '12:18',
    views: '96.3万',
    tag: '热门',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20with%20spotlights%20and%20confetti%20falling%2C%20entertainment%20TV%20production%20set%2C%20colorful%20stage%20lighting%20on%20empty%20platform%2C%20dramatic%20theatrical%20atmosphere%2C%20professional%20broadcast%20quality%2C%20warm%20golden%20and%20red%20tones&width=480&height=320&seq=91crab-media-03&orientation=landscape',
    title: '综艺节目名场面合集高清回看',
    duration: '08:45',
    views: '87.1万',
    tag: '热门',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Paparazzi%20style%20night%20street%20photography%20scene%20with%20blurred%20figures%20and%20city%20lights%2C%20urban%20nighttime%20atmosphere%2C%20dramatic%20shadows%20and%20warm%20street%20lamp%20glow%2C%20mysterious%20and%20intriguing%20mood%2C%20cinematic%20composition&width=480&height=320&seq=91crab-media-04&orientation=landscape',
    title: '娱乐圈最新绯闻独家深度爆料',
    duration: '15:20',
    views: '72.5万',
    tag: '独家',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20feed%20displayed%20on%20large%20screen%20with%20trending%20topics%20and%20notifications%2C%20modern%20digital%20newsroom%20concept%2C%20warm%20amber%20glow%20from%20screen%2C%20tech%20minimal%20workspace%2C%20editorial%20photography%20style%2C%20clean%20and%20professional&width=480&height=320&seq=91crab-media-05&orientation=landscape',
    title: '某品牌代言争议事件始末整理',
    duration: '10:05',
    views: '65.8万',
    tag: '跟进',
  },
];

const cardItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Award%20ceremony%20stage%20with%20golden%20trophy%20and%20red%20carpet%2C%20glamorous%20entertainment%20event%20scene%2C%20warm%20spotlight%20illumination%2C%20luxurious%20and%20elegant%20atmosphere%2C%20professional%20event%20photography%2C%20sophisticated%20composition%20with%20bokeh%20background&width=600&height=400&seq=91crab-card-01&orientation=landscape',
    title: '某颁奖礼后台名场面独家还原',
    desc: '近期某大型颁奖典礼后台发生的精彩互动全过程，多位明星意外交集引发热议。',
    date: '2026-07-29',
    category: '娱乐圈',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20musical%20instruments%20and%20dramatic%20lighting%2C%20live%20music%20performance%20atmosphere%2C%20warm%20stage%20spotlights%20and%20fog%20effects%2C%20energetic%20and%20dynamic%20scene%2C%20professional%20concert%20photography%20quality&width=600&height=400&seq=91crab-card-02&orientation=landscape',
    title: '音乐节演出争议事件深度分析',
    desc: '某音乐节现场歌手与观众发生争执的完整时间线梳理，内幕比你想象的更复杂。',
    date: '2026-07-28',
    category: '音乐圈',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Fashion%20runway%20show%20with%20models%20and%20designer%20clothing%2C%20luxury%20brand%20event%20atmosphere%2C%20warm%20golden%20lighting%2C%20elegant%20and%20sophisticated%20style%2C%20high%20fashion%20editorial%20photography%2C%20clean%20modern%20aesthetic&width=600&height=400&seq=91crab-card-03&orientation=landscape',
    title: '某奢侈品牌大秀幕后花絮曝光',
    desc: '知名奢侈品牌最新大秀的幕后花絮和相关争议，涉及多位艺人出席细节。',
    date: '2026-07-27',
    category: '时尚圈',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20camera%20equipment%20and%20director%20chair%2C%20movie%20production%20behind%20the%20scenes%2C%20warm%20cinematic%20lighting%20on%20set%2C%20professional%20film%20crew%20working%20atmosphere%2C%20creative%20and%20artistic%20environment&width=600&height=400&seq=91crab-card-04&orientation=landscape',
    title: '某电影剧组内部矛盾被曝出',
    desc: '即将上映的某大片拍摄期间剧组内部矛盾的来龙去脉，涉及导演与主演之争。',
    date: '2026-07-26',
    category: '影视圈',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20studio%20apartment%20interior%20with%20ring%20light%20and%20camera%20setup%2C%20content%20creator%20workspace%2C%20warm%20cozy%20lighting%20with%20plants%20and%20decor%2C%20lifestyle%20photography%20aesthetic%2C%20clean%20and%20minimal%20design%2C%20natural%20and%20inviting%20atmosphere&width=600&height=400&seq=91crab-card-05&orientation=landscape',
    title: '知名博主私下聚会视频流出',
    desc: '多位知名博主私下聚会现场视频曝光，聚会中的言行引发粉丝群体广泛讨论。',
    date: '2026-07-25',
    category: '网红圈',
  },
];

export default function MediaCardsSection() {
  return (
    <>
      <section id="media" className="relative py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              精彩视频
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              最新最热的吃瓜视频，点击即可在线观看完整内容
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {mediaItems.map((item, idx) => (
              <div
                key={idx}
                className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-video overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                      if (target.parentElement) {
                        target.parentElement.style.display = 'none';
                      }
                    }}
                  />
                  <div className="absolute inset-0 bg-black/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-14 h-14 flex items-center justify-center bg-primary-500/90 rounded-full">
                      <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 rounded text-[10px] text-background-50 font-mono whitespace-nowrap">
                    {item.duration}
                  </div>
                  <div className="absolute top-2 left-2">
                    <span className="inline-block px-2 py-0.5 bg-primary-500 text-background-50 text-[10px] font-medium rounded whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {item.views}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="cards" className="relative py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              深度爆料
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              精选深度吃瓜内容，带你全方位了解事件始末
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cardItems.map((item, idx) => (
              <div
                key={idx}
                className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-[3/2] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                      if (target.parentElement) {
                        target.parentElement.style.display = 'none';
                      }
                    }}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="inline-block px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-xs font-medium text-accent-600 rounded-md whitespace-nowrap">
                      {item.category}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                    {item.desc}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-400">{item.date}</span>
                    <span className="text-xs text-primary-500 font-medium flex items-center gap-1 whitespace-nowrap">
                      阅读全文
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}